<app-auth-layout
  variant="split"
  [headline]="'user.authAside.callback.headline' | transloco"
  [tagline]="'user.authAside.callback.tagline' | transloco"
>
  <div class="callback">
    <p-progressSpinner strokeWidth="4"></p-progressSpinner>
    <p class="auth-subtitle">{{ 'user.authCallback.authenticating' | transloco }}</p>
  </div>
</app-auth-layout>
